"use strict";
const { MESSAGE_TYPES } = require('@whispir/workflow-factory');
const { object, string, boolean, array } = require('../../utils/modifiedYup');
const { webLinkSchema, webFormSchema } = require('./linkSchema');
const { smsRecipientsSchema, emailRecipientsSchema, } = require('./recipientSchema');
const { smsMessageSchema, emailMessageSchema } = require('./messageSchema');
const sendSmsSchema = object().shape({
    stepName: string().required(),
    collectResponses: boolean().required(),
    workspaceId: string().required(),
    message: smsMessageSchema.required(),
    link: object().oneOfSchemas([webLinkSchema], true).nullable(),
    recipients: smsRecipientsSchema.required(),
});
const sendEmailSchema = object().shape({
    stepName: string().required(),
    workspaceId: string().required(),
    message: emailMessageSchema.required(),
    link: object().oneOfSchemas([webLinkSchema], true).nullable(),
    recipients: emailRecipientsSchema.required(),
});
const sendWebformSchema = object().shape({
    stepName: string().required(),
    workspaceId: string().required(),
    message: object()
        .oneOfSchemas([smsMessageSchema, emailMessageSchema], false)
        .required(),
    link: object().oneOfSchemas([webFormSchema]).required(),
    recipients: array()
        .when(['message'], {
        is: (message = {}) => message.type === MESSAGE_TYPES.SMS,
        then: smsRecipientsSchema.required(),
    })
        .when(['message'], {
        is: (message = {}) => message.type === MESSAGE_TYPES.EMAIL,
        then: emailRecipientsSchema.required(),
    }),
});
module.exports = {
    sendSmsSchema,
    sendEmailSchema,
    sendWebformSchema,
};
//# sourceMappingURL=dataSchema.js.map